import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loginFormIsValid: true,
};
const formLoginValidationSlice = createSlice({
  name: "formLoginValidationSlice",
  initialState,
  reducers: {
    setLoginFormValid: (state, action) => {
      state.loginFormIsValid = action.payload;
    },
  },
});

export const { setLoginFormValid } = formLoginValidationSlice.actions;

export default formLoginValidationSlice.reducer;
